import { useEffect, useState } from "react";
import { SearchX, Trash2, TrendingUp } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

const TABS = [
  { id: "misses", label: "Não encontrados" },
  { id: "all", label: "Todas as buscas" },
];

const when = (iso) => (iso ? new Date(iso).toLocaleDateString("pt-BR", { day: "2-digit", month: "short" }) : "");

const Row = ({ s, onRemove }) => (
  <li data-testid={`admin-search-row-${s.term}`} className="flex items-center gap-3 border-t border-white/10 py-3 first:border-t-0">
    <span className="min-w-0 flex-1">
      <span className="block truncate font-semibold text-white">{s.label}</span>
      <span className="block text-xs text-zinc-400">
        {s.count} {s.count === 1 ? "busca" : "buscas"} · {s.misses} sem resultado{s.orders ? ` · ${s.orders} ${s.orders === 1 ? "pedido" : "pedidos"}` : ""}{s.alerts ? ` · ${s.alerts} ${s.alerts === 1 ? "aviso" : "avisos"}` : ""} · {when(s.last_at)}
      </span>
    </span>
    {s.last_results === 0 && <span className="hidden shrink-0 rounded-full bg-amber-300/10 px-2.5 py-1 text-[11px] font-semibold text-amber-300 sm:inline">Sem estoque</span>}
    <button data-testid={`admin-search-remove-${s.term}`} onClick={() => onRemove(s)} aria-label={`Remover ${s.label}`} title="Remover da lista" className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-zinc-400 hover:bg-white/10 hover:text-white">
      <Trash2 className="h-4 w-4" />
    </button>
  </li>
);

export const TopSearches = () => {
  const [items, setItems] = useState([]);
  const [tab, setTab] = useState("misses");

  useEffect(() => {
    api.get("/admin/searches").then((r) => setItems(Array.isArray(r?.data) ? r.data : [])).catch(() => setItems([]));
  }, []);

  const remove = async (s) => {
    try {
      await api.delete("/admin/searches", { params: { term: s.term } });
      setItems((list) => list.filter((x) => x.term !== s.term));
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  const list = (tab === "misses" ? items.filter((s) => s.misses > 0) : [...items].sort((a, b) => b.count - a.count)).slice(0, 10);

  return (
    <section data-testid="admin-top-searches" className="mt-8 rounded-[24px] border border-white/10 bg-[#111113] p-5 sm:p-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-2.5">
          <TrendingUp className="h-5 w-5 text-white" />
          <h2 className="font-display text-xl font-bold">Mais procurados</h2>
        </div>
        <div className="flex w-fit gap-1 rounded-full border border-white/10 p-1">
          {TABS.map((t) => (
            <button key={t.id} data-testid={`admin-searches-tab-${t.id}`} onClick={() => setTab(t.id)}
              className={`rounded-full px-4 py-1.5 text-sm transition-colors ${tab === t.id ? "bg-white text-black" : "text-zinc-300 hover:text-white"}`}>{t.label}</button>
          ))}
        </div>
      </div>
      <p className="mt-2 text-sm text-zinc-400">O que os clientes digitam na lupinha do site. Use os "não encontrados" para saber o que vale a pena comprar.</p>
      {list.length ? (
        <ul data-testid="admin-searches-list" className="mt-4">{list.map((s) => <Row key={s.term} s={s} onRemove={remove} />)}</ul>
      ) : (
        <p data-testid="admin-searches-empty" className="mt-4 flex items-center gap-2 rounded-2xl border border-dashed border-white/15 p-5 text-sm text-zinc-400">
          <SearchX className="h-4 w-4 shrink-0" /> {tab === "misses" ? "Nenhuma busca sem resultado ainda." : "Nenhuma busca registrada ainda."}
        </p>
      )}
    </section>
  );
};
